import { NgModule } from '@angular/core';
import { PermissionService } from './services/permission.service';
import { CanActivateDirective } from './directives/can-activate.directive';
import { CanEditDirective } from './directives/can-edit.directive';
import { PermissionGuard } from './services/permission-guard.service';

@NgModule({
  declarations: [CanActivateDirective, CanEditDirective],
  exports: [CanActivateDirective, CanEditDirective],
  providers: [PermissionService, PermissionGuard],
})
export class PermissionModule {}
